const chunkArray = <T>(array: T[], chunkSize: number) =>
  array.reduce<T[][]>((acc, item, index) => {
    const chunk = Math.floor(index / chunkSize);
    acc[chunk] = [...(acc[chunk] || []), item];

    return acc;
  }, []);

export default chunkArray;
